import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('MARKETPLACE_COMMUNITY')